import i18next from "i18next";
import React, { ChangeEvent } from "react";
import { useSearchContext } from "../../Contexts/SearchContext";
import { Select } from "../../Elements/Select";

export const SearchGroup = (): JSX.Element => {
    const { groups, selectedGroup, setSelectedGroup, setSearchHelp, setResultFeatures, setError, setNotification } =
        useSearchContext();

    const onClickGroup = (e: ChangeEvent<HTMLSelectElement>) => {
        const groupValue = groups.find((o) => o.label === e.target.value);

        setSelectedGroup(groupValue);
        setSearchHelp(true);
        setResultFeatures([]);
        setError("");
        setNotification("");
    };

    return (
        <div className="search-select-group">
            <div className="field-input">
                <Select
                    title={i18next.t("searchPanel.selectGroup")}
                    config={{ field: "searchGroup" }}
                    options={groups}
                    defaultValue={selectedGroup.label}
                    onChange={onClickGroup}
                />
            </div>
        </div>
    );
};
